import { createSelector } from 'reselect';

import { AppStateType } from '@lib/core/service/types/appStateType';

/**
 * @returns wellness slice state
 */
const selectWellnessState = (state: AppStateType) => state?.productAttributes?.wellness;

/**
 * @returns wellness data array
 */
export const selectWellnessData = createSelector([selectWellnessState], wellness => wellness?.data);

/**
 * @returns wellness loading state
 */
export const selectIsWellnessLoading: (state) => boolean = createSelector(
  [selectWellnessState],
  wellness => wellness?.isLoading || false,
);
